import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaptopCode,
  faRobot,
  faMicrochip,
  faShieldAlt,
  faVrCardboard,
  faChain,
} from "@fortawesome/free-solid-svg-icons";
const Services = () => {
  const services = [
    {
      icon: faLaptopCode,
      title: "Fullstack",
      description: "Building robust web applications from frontend to backend.",
    },
    {
      icon: faRobot,
      title: "AI",
      description:
        "Implementing intelligent systems and machine learning models.",
    },
    {
      icon: faMicrochip,
      title: "Hardware",
      description: "Designing and developing hardware solutions.",
    },
    {
      icon: faShieldAlt,
      title: "Cyber",
      description: "Ensuring cybersecurity and protecting data.",
    },
    {
      icon: faVrCardboard,
      title: "AR/VR",
      description:
        "Creating immersive augmented and virtual reality experiences.",
    },
    {
      icon: faChain,
      title: "Blockchain",
      description:
        "Building decentralized applications using blockchain technology.",
    },
  ];
  return (
    <section
      id="features"
      className="w-full mx-auto  px-4 space-y-6 bg-gray-900 py-8 md:py-12 lg:py-20 text-white"
    >
      <div className="mx-auto flex max-w-[58rem] flex-col items-center space-y-4 text-center">
        <h2 className="font-bold text-3xl leading-[1.1] sm:text-3xl md:text-6xl">
          Our Services
        </h2>
        <p className="max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7">
          We offer a range of services to cater to your needs, leveraging
          cutting-edge technologies to deliver innovative solutions.
        </p>
      </div>
      <div className="mx-auto grid justify-center gap-4 sm:grid-cols-2 md:max-w-[64rem] md:grid-cols-3">
        {services.map((service, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-lg border bg-gray-800 select-none hover:shadow hover:shadow-teal-200 p-2"
          >
            <div className="flex h-[180px] flex-col justify-between rounded-md p-6">
              <FontAwesomeIcon
                icon={service.icon}
                className="h-12 w-12 text-teal-400"
              />
              <div className="space-y-2">
                <h3 className="font-bold">{service.title}</h3>
                <p className="text-sm text-gray-400">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
